import Upload from '../StudyFileUpload';

export const AttachmentFileAcceptType =
  '.jfif, .pjpeg, .jpeg, .pjp, .jpg, .png, .gif, .tiff, .tif, .mpg, .mpeg, .m4v, .mp4, .mov, .pdf, .xslt, .xbl, .xsl, .xml, .webm';

const AttachmentFile = ({
  open,
  onCancel,
  params,
  modal,
  message,
}: {
  open: Parameters<typeof Upload>[0]['open'];
  onCancel: Parameters<typeof Upload>[0]['onCancel'];
  params: Parameters<typeof Upload>[0]['params'];
  modal: Parameters<typeof Upload>[0]['modal'];
  message: Parameters<typeof Upload>[0]['message'];
}) => {
  return (
    <Upload
      acceptType={AttachmentFileAcceptType}
      appearance="attachment"
      {...{
        open,
        onCancel,
        params,
        modal,
        message,
      }}
    />
  );
};

export default AttachmentFile;
